// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pf-0";